/* src/app/shared/components/lead-details-address/lead-details-address.component.css */
input:read-only {
  cursor: default;
  background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
  color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
}
::ng-deep nz-switch .ant-switch:focus-visible {
  outline: none;
  transition: box-shadow 0.3s ease;
}
::ng-deep nz-switch .ant-switch.ant-switch-checked:focus-visible {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.3);
  border-color: #40a9ff;
}
::ng-deep nz-switch .ant-switch:not(.ant-switch-checked):focus-visible {
  box-shadow: 0 0 0 3px rgba(150, 150, 150, 0.3);
  border-color: #d9d9d9;
}
::ng-deep .p-autocomplete {
  width: 100%;
}
/*# sourceMappingURL=lead-details-address.component-CIJE3LAG.css.map */
